export default __webpack_public_path__ + "static/media/640_portfolio02-en-mobile.f1c7e40b.png";